/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientIntakeForms = sqliteTable('patient_intake_forms', {
  id: text('id').primaryKey().notNull(),
  patient_id: text('patient_id'),
  intake_form_definition_id: text('intake_form_definition_id'),
  status: text('status'),
  completed_at: text('completed_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
